import { StorageService } from './core/storageService';
import { CONVERSATION_CACHE_MS } from '../config/security';
import { licenseKeyPrefix } from '../utils/helpers';

export class ConversationService {
  constructor(licenseToken, sessionToken, httpClient) {
    this.licenseToken = licenseToken;
    this.sessionToken = sessionToken;
    this.httpClient = httpClient;
    this.storage = new StorageService('tiagpc');
  }


  _getLastConversationKey() {
    return `last_conversation_${licenseKeyPrefix(this.licenseToken)}`;
  }


  async listConversations(limit = 20, offset = 0) {
    const response = await this.httpClient.get('/conversations', {
      params: { limit, offset },
      headers: {
        'X-Session-Token': this.sessionToken
      }
    });
    return response;
  }


  async getConversationHistory(conversationId, limit = 50, offset = 0) {
    const response = await this.httpClient.get(
      `/conversation/${conversationId}/history`,
      { params: { limit, offset } }
    );
    return response;
  }


  async getCurrentConversation() {
    const response = await this.httpClient.get('/conversation/current', {
      headers: {
        'X-Session-Token': this.sessionToken
      }
    });
    return response;
  }


  saveLastConversation(conversationId, messages) {
    const key = this._getLastConversationKey();
    return this.storage.setWithTimestamp(key, {
      conversationId,
      messages
    });
  }


  getLastConversation(maxAge = CONVERSATION_CACHE_MS) {
    const key = this._getLastConversationKey();
    return this.storage.getWithExpiry(key, maxAge);
  }


  clearLastConversation() {
    const key = this._getLastConversationKey();
    return this.storage.remove(key);
  }


  hasLastConversation() {
    const key = this._getLastConversationKey();
    return this.storage.has(key);
  }


  async updateConversationTitle(conversationId, newTitle) {
    const response = await this.httpClient.patch(
      `/conversation/${conversationId}/title`,
      { new_title: newTitle },
      {
        headers: {
          'X-Session-Token': this.sessionToken
        }
      }
    );
    return response;
  }


  async deleteConversation(conversationId) {
    const response = await this.httpClient.delete(
      `/conversation/${conversationId}`,
      {
        headers: {
          'X-Session-Token': this.sessionToken
        }
      }
    );
    return response;
  }
}
